<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.school_year'),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection class="mt-5">
                <template v-slot:title> {{ $t('messages.trimester') }} 1 </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 1,
                                    })
                                "
                                for="first_trimester_start_date"
                            />
                            <FormInput
                                required
                                id="first_trimester_start_date"
                                v-model="form.first_trimester_start_date"
                                name="first_trimester_start_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.first_trimester_start_date" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 1,
                                    })
                                "
                                for="first_trimester_end_date"
                            />
                            <FormInput
                                required
                                id="first_trimester_end_date"
                                v-model="form.first_trimester_end_date"
                                name="first_trimester_end_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.first_trimester_end_date" class="mt-2" />
                        </div>
                    </div>
                    <div class="sm:col-span-6"></div>
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.trimester_corner_date')"
                                for="first_trimester_corner_date"
                            />
                            <FormInput
                                id="first_trimester_corner_date"
                                v-model="form.first_trimester_corner_date"
                                name="first_trimester_corner_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.first_trimester_corner_date" class="mt-2" />
                            <div class="text-xs text-gray-500">
                                {{ $t('messages.trimester_corner_date_explanation') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="stage in options.stages" :key="stage.value">
                    <div>
                        {{ stage.text }}
                    </div>
                    <div class="mt-1">
                        <FormLabel
                            :value="$t('messages.trimester_show_reports_date')"
                            for="first_trimester_show_reports_date"
                        />
                        <FormInput
                            id="first_trimester_show_reports_date"
                            v-model="form.settings.first.stages[stage.value].show_reports_date"
                            name="first_trimester_show_reports_date"
                            type="datetime-local"
                            class="mt-1"
                        />
                        <FormError
                            :value="form.errors[`settings.first.stages.${stage.value}.show_reports_date`]"
                            class="mt-2"
                        />
                    </div>
                </div>
            </TitleFieldsFormSection>
            <hr class="my-3" />
            <TitleFieldsFormSection class="mt-5">
                <template v-slot:title> {{ $t('messages.trimester') }} 2 </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 2,
                                    })
                                "
                                for="second_trimester_start_date"
                            />
                            <FormInput
                                required
                                id="second_trimester_start_date"
                                v-model="form.second_trimester_start_date"
                                name="second_trimester_start_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.second_trimester_start_date" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 2,
                                    })
                                "
                                for="second_trimester_end_date"
                            />
                            <FormInput
                                required
                                id="second_trimester_end_date"
                                v-model="form.second_trimester_end_date"
                                name="second_trimester_end_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.second_trimester_end_date" class="mt-2" />
                        </div>
                    </div>
                    <div class="sm:col-span-6"></div>
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.trimester_corner_date')"
                                for="second_trimester_corner_date"
                            />
                            <FormInput
                                id="second_trimester_corner_date"
                                v-model="form.second_trimester_corner_date"
                                name="second_trimester_corner_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.second_trimester_corner_date" class="mt-2" />
                            <div class="text-xs text-gray-500">
                                {{ $t('messages.trimester_corner_date_explanation') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="stage in options.stages" :key="stage.value">
                    <div>
                        {{ stage.text }}
                    </div>
                    <div class="mt-1">
                        <FormLabel
                            :value="$t('messages.trimester_show_reports_date')"
                            for="second_trimester_show_reports_date"
                        />
                        <FormInput
                            id="second_trimester_show_reports_date"
                            v-model="form.settings.second.stages[stage.value].show_reports_date"
                            name="second_trimester_show_reports_date"
                            type="datetime-local"
                            class="mt-1"
                        />
                        <FormError
                            :value="form.errors[`settings.second.stages.${stage.value}.show_reports_date`]"
                            class="mt-2"
                        />
                    </div>
                </div>
            </TitleFieldsFormSection>
            <hr class="my-3" />
            <TitleFieldsFormSection class="mt-5">
                <template v-slot:title> {{ $t('messages.trimester') }} 3 </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 3,
                                    })
                                "
                                for="third_trimester_start_date"
                            />
                            <FormInput
                                required
                                id="third_trimester_start_date"
                                v-model="form.third_trimester_start_date"
                                name="third_trimester_start_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.third_trimester_start_date" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 3,
                                    })
                                "
                                for="third_trimester_end_date"
                            />
                            <FormInput
                                required
                                id="third_trimester_end_date"
                                v-model="form.third_trimester_end_date"
                                name="third_trimester_end_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.third_trimester_end_date" class="mt-2" />
                        </div>
                    </div>
                    <div class="sm:col-span-6"></div>
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.trimester_corner_date')"
                                for="third_trimester_corner_date"
                            />
                            <FormInput
                                id="third_trimester_corner_date"
                                v-model="form.third_trimester_corner_date"
                                name="third_trimester_corner_date"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.third_trimester_corner_date" class="mt-2" />
                        </div>
                    </div>
                </div>
                <div v-for="stage in options.stages" :key="stage.value">
                    <div>
                        {{ stage.text }}
                    </div>
                    <div class="mt-1">
                        <FormLabel
                            :value="$t('messages.trimester_show_reports_date')"
                            for="third_trimester_show_reports_date"
                        />
                        <FormInput
                            id="third_trimester_show_reports_date"
                            v-model="form.settings.third.stages[stage.value].show_reports_date"
                            name="third_trimester_show_reports_date"
                            type="datetime-local"
                            class="mt-1"
                        />
                        <FormError
                            :value="form.errors[`settings.third.stages.${stage.value}.show_reports_date`]"
                            class="mt-2"
                        />
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :processing="form.processing" :button-text="$t('messages.save')" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['schoolYear', 'meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                first_trimester_start_date: this.schoolYear.first_trimester_start_date,
                first_trimester_end_date: this.schoolYear.first_trimester_end_date,
                second_trimester_start_date: this.schoolYear.second_trimester_start_date,
                second_trimester_end_date: this.schoolYear.second_trimester_end_date,
                third_trimester_start_date: this.schoolYear.third_trimester_start_date,
                third_trimester_end_date: this.schoolYear.third_trimester_end_date,
                first_trimester_corner_date: this.schoolYear.first_trimester_corner_date,
                second_trimester_corner_date: this.schoolYear.second_trimester_corner_date,
                third_trimester_corner_date: this.schoolYear.third_trimester_corner_date,
                settings: this.schoolYear.settings,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
